<dynamic-container #controlRef [config]="config" [formGroup]="group">
  <cwc-checkbox
    [formControlName]="config.name"
    [attr.required]="controlRef.isRequired"
    [attr.status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : null"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    class="m-end-sm"
  >
    {{ config.label | translate }}
  </cwc-checkbox>
</dynamic-container>
